module.exports = __webpack_public_path__ + "static/media/send-message-icon 1.5f285d60.svg";